<template>
    <div>
        <loading
            :active.sync="loader.isLoading"
            :can-cancel="loader.canCancel"
            :is-full-page="loader.fullPage"
            :color="loader.color"
            :height="loader.height"
            :width="loader.width"
            :background-color="loader.backgroundColor"
            :loader="loader.loader">
            </loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Customer Piutang</h4>
                        <div class="form-inline">
                            <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                                <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <div class="form-group mx-sm-3 mb-2">
                                <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                            </div>
                            <div class="button-group">
                                <!-- <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" data-toggle="modal" data-target="#modalCustomerBirthday" data-backdrop="static" data-keyboard="false">Send Birthday</button> -->
                                <!-- <button type="button" class="btn btn-sm btn-soft-primary waves-lithg waves-effect" @click="sendMessage">Test</button> -->
                                rows:
                                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                                <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                                </select>
                                <span class="mr-1">
                                Total rows: <b>{{ rowsTotal }}</b>
                                </span>
                            </div>
                            <span class="mr-1">
                                page:
                                <select v-model="currentPage">
                                <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                                </select>
                                / {{ pageLength }}
                            </span>
                            <nav aria-label="Page navigation example" class="pull-right">
                                <ul class="pagination">
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li class="page-item">
                                        <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-small-list">
                    <div class="card-body">
                    <div class="table-responsive">
                        <span class="pull-right mb-2 font-14" style="font-weight: 800"><i class="fa fa-cart-plus" aria-hidden="true"></i> Outstanding: {{ totalOutstanding | currency }}</span>
                        <table class="table table-item mb-0 table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" @click="select">
                                        <i class="form-icon"></i>
                                    </label>
                                    </th>
                                    <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                        {{ t.name }}
                                        <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-if="filterData.length < 1">
                                <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                            </tr>
                                <tr v-for="u in filterData" v-bind:key="u.id">
                                <td>
                                    <label class="form-checkbox">
                                    <input type="checkbox" :value="u.id" v-model="selected">
                                    <i class="form-icon"></i>
                                    </label>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="u.status === 'approved'">{{ u.status }}</span>
                                    <span class="badge badge-warning" v-else>{{ u.status }}</span>
                                </td>
                                <td>
                                    <span style="cursor: pointer" @click="getSaleNo(u.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false"><b>{{ u.sale_no }}</b></span></td>
                                <td>{{ u.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td><b>{{ u.term_due }}</b></td>
                                <td>{{ u.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ u.company }}</td>
                                <td><b>{{ u.customer }}</b></td>
                                <td>{{ u.salesman }}</td>
                                <td class="text-right">{{ u.subtotal | currency}}</td>
                                <td class="text-right">{{ u.discount | currency}}</td>
                                <td class="text-right">{{ u.tax | currency}}</td>
                                <td class="text-right">{{ u.total | currency }}</td>
                                <td class="text-right">{{ u.payment_balance | currency }}</td>
                                <td class="text-right">{{ u.outstanding | currency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { customerUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'CustomerPiutangList',
  props: ['scroll'],
  components: {
    Loading,
    SaleModal
  },
  data () {
    return {
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Sale No.',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'sale_date',
        align: 'text-left'
      }, {
        name: 'Term Due',
        prop: 'term_due',
        align: 'text-left'
      }, {
        name: 'Due Date',
        prop: 'sale_due_date',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company_no',
        align: 'text-left'
      }, {
        name: 'Customer',
        prop: 'customer',
        align: 'text-left'
      }, {
        name: 'Salesman',
        prop: 'salesman',
        align: 'text-left'
      }, {
        name: 'Subtotal',
        prop: 'subtotal',
        align: 'text-right'
      }, {
        name: 'Discount',
        prop: 'discount',
        align: 'text-right'
      }, {
        name: 'Tax',
        prop: 'tax',
        align: 'text-right'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Payment',
        prop: 'payment_balance',
        align: 'text-right'
      }, {
        name: 'Outstanding',
        prop: 'outstanding',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable
    }),
    totalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    getSaleNo (saleNo) {
      var payload = {
        sale_no: saleNo
      }
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        customer_no: null,
        date: this.dateNow,
        year: null
      }
      axios.post(customerUrl + '/piutang-sales', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('succcess', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
